import { ReactComponent as Check } from './check.svg';
import { ReactComponent as Menu } from './menu.svg';
import { ReactComponent as Loader } from './eclipse-loader.svg';
import { ReactComponent as bigLoader } from './loader.svg';
import { ReactComponent as Spinner } from 'assets/icons/spinner.svg';
import { ReactComponent as KES } from 'assets/icons/kes.svg';

const icons = {
  tick: Check,
  menu: Menu,
  loader: Loader,
  bigLoader: bigLoader,
  spinner: Spinner,
  kes: KES
};

export function getIcon(iconName) {
  let d = null;
  if (icons[iconName]) {
    return icons[iconName];
  }
  return d;
}

export default getIcon;
